// Shared validation for persisted event identity and the live editor.
const DEFAULT_BRANDING = Object.freeze({
    primary: '#D0142C', dark: '#1C1C20', background: '#FFFFFF',
    surface: '#F3F3F5', text: '#1C1C20', logo: '', animateStripes: false, stripeSpeed: 3,
});
// Stripe speed 1 (slowest) .. 10 (fastest); 3 keeps the original 48s loop.
const STRIPE_SPEED_MIN = 1, STRIPE_SPEED_MAX = 10;
function stripeSeconds(speed) { return Math.round(144 / speed * 10) / 10; }
function normalizeBranding(value) {
    if (typeof value === 'string') { try { value = JSON.parse(value); } catch (_) { value = {}; } }
    const source = value && typeof value === 'object' ? value : {};
    const result = { ...DEFAULT_BRANDING };
    for (const key of ['primary', 'dark', 'background', 'surface', 'text']) {
        if (typeof source[key] === 'string' && /^#[0-9a-f]{6}$/i.test(source[key])) result[key] = source[key];
    }
    // No script/data URLs or protocol-relative URLs in event logos.
    if (typeof source.logo === 'string' && source.logo.length <= 2048 &&
        (/^https?:\/\/[^\s]+$/i.test(source.logo) || /^\/(?!\/)[^\s\\]*$/.test(source.logo))) result.logo = source.logo;
    result.animateStripes = source.animateStripes === true;
    const speed = Number(source.stripeSpeed);
    if (Number.isFinite(speed)) result.stripeSpeed = Math.max(STRIPE_SPEED_MIN, Math.min(STRIPE_SPEED_MAX, Math.round(speed)));
    return result;
}
function contrastColor(hex) {
    const rgb = hex.slice(1).match(/../g).map(v => parseInt(v, 16) / 255)
        .map(v => v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4);
    return rgb[0] * .2126 + rgb[1] * .7152 + rgb[2] * .0722 > .179 ? '#1C1C20' : '#FFFFFF';
}
function brandingStyle(value) {
    const b = normalizeBranding(value);
    return {
        '--event-stripe-motion': b.animateStripes ? `event-stripe-drift ${stripeSeconds(b.stripeSpeed)}s linear infinite` : 'none',
        '--vc-accent-500': b.primary, '--vc-accent-600': b.primary,
        '--vc-accent-100': `color-mix(in srgb, ${b.primary} 14%, ${b.background})`,
        '--vc-ink-900': b.dark, '--vc-ink-700': b.dark,
        '--vc-paper-50': b.background, '--vc-paper-100': b.surface, '--vc-paper-200': b.surface,
        '--vc-text-900': b.text, '--vc-text-600': `color-mix(in srgb, ${b.text} 65%, ${b.background})`,
        '--vc-line': `color-mix(in srgb, ${b.text} 15%, ${b.background})`,
        '--vc-line-strong': `color-mix(in srgb, ${b.text} 25%, ${b.background})`,
        '--event-on-primary': contrastColor(b.primary), '--event-on-dark': contrastColor(b.dark),
    };
}
module.exports = { DEFAULT_BRANDING, STRIPE_SPEED_MIN, STRIPE_SPEED_MAX, normalizeBranding, brandingStyle, contrastColor };
